import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { API_URL } from '../config/api.config';
import { ApiResponse } from '../models/api.model';
import { AuditFilters, AuditPage } from '../models/audit.model';

const EMPTY_PAGE: AuditPage = { items: [], page: 1, pageSize: 25, totalItems: 0, totalPages: 0 };

@Injectable({ providedIn: 'root' })
export class AuditService {
  private readonly http = inject(HttpClient);

  getRecords(filters: AuditFilters, page = 1, pageSize = 25): Observable<AuditPage> {
    let params = new HttpParams().set('page', page).set('pageSize', pageSize);
    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        const normalizedValue =
          key === 'desde'
            ? `${value}T00:00:00.000Z`
            : key === 'hasta'
              ? `${value}T23:59:59.999Z`
              : value;
        params = params.set(key, normalizedValue);
      }
    });

    return this.http
      .get<ApiResponse<AuditPage>>(`${API_URL}/auditoria`, { params })
      .pipe(map((response) => response.data ?? EMPTY_PAGE));
  }
}
